
import { constructsData } from '../../Components/StudentPerformanceDashboard/data'

export const fetchGamesReportStatus = (payload) => {
  return {
    type: 'FETCH_GAMES_REPORTS_STATUS',
    payload: payload
  }
}

export const setActiveTab = (tab) => ({
  type: 'SET_ACTIVE_TAB',
  payload: tab,
});

let timeout;
function debounce(func, wait) {
  return function (...args) {
    const later = () => {
      clearTimeout(timeout);
      func(...args);
    };
    clearTimeout(timeout);
    timeout = setTimeout(later, wait);
  };
}

export const updateBehaviorPercentage = (payload) => (dispatch, getState) => {
  let { activeBehaviorsection: construct_label, userId } = getState().studentPerformenceConstruct

  dispatch({
    type: 'UPDATE_BEHAVIOR_PERCENTAGE',
    payload
  });

  debounce(() => {
    dispatch(updatePredictionBYBehaviorData({ modified_features: payload?.modified_features, construct_label, user_id: userId }))
  }, 2000)()
}

export const resetBehaviorPercentage = (payload) => (dispatch, getState) => {
  let { activeBehaviorsection: construct_name, contextData, userId } = getState().studentPerformenceConstruct
  let modified_features = {}
  contextData?.behaviors[construct_name].forEach((item) => {
    if ('originalPercentage' in item) {
      modified_features = {
        ...modified_features,
        [item?.label]: +item?.originalPercentage
      }
    }
  })
  debounce(() => {
    dispatch(updatePredictionBYBehaviorData({ modified_features, construct_label: construct_name, user_id: userId })).then((response) => {
      dispatch({
        type: 'RESET_BEHAVIOR_PERCENTAGE',
        payload: response
      });
    })
  }, 500)()
  // originalPercentage
  // modified_features: {"slide_extra_levels":51}
  // construct_label: Slide_ChallengeSeeking_Seeking



}

export const fetchContextDataStart = () => ({
  type: 'FETCH_CONTEXT_DATA_START',
});

export const fetchConstructDataSuccess = (data) => ({
  type: 'FETCH_CONSTRUCT_DATA_SUCCESS',
  payload: data,
});

export const fetchConstructDataFailure = (error) => ({
  type: 'FETCH_CONSTRUCT_DATA_FAILURE',
  payload: error,
});

export const fetchContextDataSuccess = (data) => ({
  type: 'FETCH_CONTEXT_DATA_SUCCESS',
  payload: data,
});

export const fetchContextDataFailure = (error) => ({
  type: 'FETCH_CONTEXT_DATA_FAILURE',
  payload: error,
});

export const fetchConstructData = (params) => ({
  type: 'FETCH_CONSTRUCT_DATA',
  method: 'get',
  params,
  url: "/api/v1/report_data",
  // URLEndPoint: 'CURD_ORGANISATION_SERVICE',
  axiosService: true,
  withResponseReturnData: params,
  toaster: {
    loading: true
  }
})

export const fetchGameTabStatusForReporting = (params) => ({
  type: 'FETCH_GAME_TABS_STATUS_FOR_REPORTING',
  method: 'get',
  params,
  url: "/api/v1/check_construct_data",
  // URLEndPoint: 'CURD_ORGANISATION_SERVICE',
  axiosService: true,
  withResponseReturnData: params,
})

export const fetchWorldGamesReport = (params) => {
  return {
    type: 'FETCH_WORLD_GAMES_REPORTS',
    method: 'get',
    params,
    url: "/api/v1/fetch_divergent_report",
    axiosService: true,
  }
}

// export const fetchConstructData = (constructName) => async (dispatch) => {
//   dispatch({ type: 'FETCH_CONSTRUCT_DATA_START' })
//   dispatch(setActiveTab('slide'))
//   dispatch(fC({ game: 'Match', category: "ProblemSolving" }))
//   try {
//     const response = await new Promise((resolve) =>
//       setTimeout(() => {
//         resolve(constructsData.find((item) => item.name.toLowerCase() === constructName.toLowerCase()));
//       }, 50)
//     );

//     if (response) {
//       dispatch(fetchConstructDataSuccess(response));
//     } else {
//       throw new Error('Construct not found');
//     }
//   } catch (error) {
//     dispatch(fetchConstructDataFailure(error.message));
//   }
// };
// ({
//   type: 'FETCH_CONTEXT_BEHAVIOR_DATA',
//   method: 'get',
//   params,
//   url: "/api/v1/behaviour_data",
//   // URLEndPoint: 'CURD_ORGANISATION_SERVICE',
//   axiosService: true,
//   withResponseReturnData: params,
//   toaster: {
//     loading: true
//   }
// })

export const fetchContextBehaviorData = (params) => ({
  type: 'FETCH_CONSTRUCT_BEHAVIOR_DATA',
  method: 'get',
  params,
  url: "/api/v1/behaviour_data",
  // URLEndPoint: 'CURD_ORGANISATION_SERVICE',
  axiosService: true,
  toaster: {
    loading: true
  }
})

// run_edit_prediction

export const updatePredictionBYBehaviorData = (params) => ({
  type: 'UPDATE_PREDICTION_dATA',
  method: 'get',
  params,
  url: "/api/v1/run_edit_prediction",
  // URLEndPoint: 'CURD_ORGANISATION_SERVICE',
  // withResponseReturnData: params,
  axiosService: true,
  toaster: {
    loading: true
  }
})
// export const fetchContextData = (constructName, currentGameName) => async (dispatch) => {
//   dispatch(fetchContextDataStart());
//   try {
//     const response = await new Promise((resolve) =>
//       setTimeout(() => {
//         resolve(constructsData.find((item) => item.name.toLowerCase() === constructName.toLowerCase())?.contexts?.[currentGameName]);
//       }, 1000)
//     );

//     if (response) {
//       dispatch(fetchContextDataSuccess(response));
//       dispatch(setActiveBehaviorSection(response?.construct_label ? response?.construct_label[0]?.behaviors_graph_key : ''))

//     } else {
//       throw new Error('Construct not found');
//     }
//   } catch (error) {
//     dispatch(fetchContextDataFailure(error.message));
//   }
// };

export const setActiveBehaviorSection = (tab) => ({
  type: 'SET_ACTIVE_BEHAVIOR_SECTION',
  payload: tab,
});
